const MESES: Record<string, number> = {
  janeiro: 1,
  fevereiro: 2,
  marco: 3,
  março: 3,
  abril: 4,
  maio: 5,
  junho: 6,
  julho: 7,
  agosto: 8,
  setembro: 9,
  outubro: 10,
  novembro: 11,
  dezembro: 12,
};

export type CampoAusenteDoConvite = "assunto" | "data" | "horário" | "link";

export interface ConviteInterpretado {
  assunto: string | null;
  quando: string | null;
  duracaoMin: number | null;
  link: string | null;
  ausentes: CampoAusenteDoConvite[];
}

function doisDigitos(valor: number): string {
  return String(valor).padStart(2, "0");
}

/** Interpreta o texto que o Google Calendar copia para um convite em português. */
export function interpretarConviteDaReuniao(texto: string, agora = new Date()): ConviteInterpretado {
  const linhas = texto
    .split(/\r?\n/)
    .map((linha) => linha.trim())
    .filter(Boolean);
  const assunto = linhas.at(0) ?? null;

  /* Sem o ano obrigatório, "2 de módulos" também casa: vale a primeira ocorrência com mês. */
  const data = [...texto.matchAll(/\b(\d{1,2})\s+de\s+([a-zç]+)(?:\s+de\s+(\d{4}))?\b/gi)]
    .find((ocorrencia) => MESES[ocorrencia[2]!.toLocaleLowerCase("pt-BR")] !== undefined);
  const horario = texto.match(/\b([01]?\d|2[0-3]):([0-5]\d)\s*[–—-]\s*([01]?\d|2[0-3]):([0-5]\d)\b/);
  const urls = [...texto.matchAll(/https:\/\/[^\s<>]+/gi)]
    .map(([endereco]) => endereco.replace(/[),.;]+$/, ""));
  const url = urls.find((endereco) => endereco.startsWith("https://meet.google.com/"))
    ?? urls[0] ?? null;

  const hoje = new Intl.DateTimeFormat("sv-SE", { timeZone: "America/Sao_Paulo" }).format(agora);
  const mes = data ? MESES[data[2]!.toLocaleLowerCase("pt-BR")] : undefined;
  const dia = data ? Number(data[1]) : 0;
  let ano = data?.[3] ? Number(data[3]) : Number(hoje.slice(0, 4));
  if (data && mes && !data[3] && `${ano}-${doisDigitos(mes)}-${doisDigitos(dia)}` < hoje) ano += 1;
  const civil = mes ? new Date(Date.UTC(ano, mes - 1, dia)) : null;
  const dataValida = mes !== undefined && civil !== null &&
    civil.getUTCFullYear() === ano && civil.getUTCMonth() === mes - 1 && civil.getUTCDate() === dia;

  let quando: string | null = null;
  let duracaoMin: number | null = null;
  if (dataValida && horario && mes) {
    const inicio = Number(horario[1]) * 60 + Number(horario[2]);
    const fim = Number(horario[3]) * 60 + Number(horario[4]);
    quando = `${ano}-${doisDigitos(mes)}-${doisDigitos(dia)}T${doisDigitos(Number(horario[1]))}:${horario[2]}`;
    duracaoMin = fim > inicio ? fim - inicio : null;
  }

  const ausentes: CampoAusenteDoConvite[] = [];
  if (!assunto) ausentes.push("assunto");
  if (!dataValida) ausentes.push("data");
  if (!horario || duracaoMin === null) ausentes.push("horário");
  if (!url) ausentes.push("link");

  return { assunto, quando, duracaoMin, link: url, ausentes };
}
